const baseURL = 'https://tahaircelulares.loanprocr.net/';

export default baseURL;
